var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","close-delay":"100"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-img',_vm._g({attrs:{"width":"32","height":"32","loading":_vm.loading,"src":require(`@/components/common/unit-icons/${_vm.statusIcon}`)}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.statusHelpText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }